<template>
  <div class="error-container" id="error-container" tabindex="-1">
    <div class="error-container__header">
      <img src="../assets/info-icon-white.svg" alt="info icon" class="error-container__header__icon" />
      <p class="error-container__header__text">{{ $t('Error') }}!</p>
    </div>
    <div class="error-container__content">
      <ul class="error-container__content__list" v-if="type == 'validation'">
        <li
          class="error-container__content__list__item"
          v-for="(errorArray, index) in Object.values(errors)"
          :key="index"
          v-show="errorArray.length > 0"
          v-html="errorArray"
        >
        </li>
      </ul>
      <div v-if="type == 'booking'">
        <p class="error-container__content__list__item" v-if="bookingErrors.includes('children')">{{
          $t('please_select_for_how_many_children')
        }}</p>
        <p class="error-container__content__list__item" v-if="bookingErrors.includes('branchType')">{{
          $t('messages.place_error')
        }}</p>
        <p class="error-container__content__list__item" v-if="bookingErrors.includes('branch')">{{
          $t('messages.choose_branch')
        }}</p>
        <p class="error-container__content__list__item" v-if="bookingErrors.includes('date')">{{
          $t('messages.date_view')
        }}</p>
        <p class="error-container__content__list__item" v-if="bookingErrors.includes('time')">{{
          $t('messages.time_view')
        }}</p>
      </div>
      <p class="error-container__content__list__item" v-else>{{ errorMsg }}</p>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useBookingStore } from '../store'
export default {
  name: 'ErrorContainer',
  components: {},
  props: {
    errors: {
      default: function () {
        return {}
      },
      required: false,
      type: Object,
    },
    type: {
      default: function () {
        return 'validation'
      },
      required: false,
      type: String,
    },
    errorMsg: {
      default: function () {
        return ''
      },
      required: false,
      type: String,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState(useBookingStore, ['bookingErrors']),
    comments: {
      get() {
        return this.comment
      },
      set(value) {
        this.setComment(value)
      },
    },
  },
  watch: {
    errors: {
      immediate: true,
      deep: true,
      handler() {
        setTimeout(() => {
          let errorContainer = document.getElementById(`error-container`)
          if (errorContainer) {
            errorContainer.focus()
          }
        }, 100)
      },
    },
    bookingErrors: {
      immediate: true,
      deep: true,
      handler() {
        setTimeout(() => {
          let errorContainer = document.getElementById(`error-container`)
          if (errorContainer) {
            errorContainer.focus()
          }
        }, 100)
      },
    },
    errorMsg: {
      immediate: true,
      deep: true,
      handler() {
        setTimeout(() => {
          let errorContainer = document.getElementById(`error-container`)
          if (errorContainer) {
            errorContainer.focus()
          }
        }, 100)
      },
    },
  },
  methods: {
    ...mapActions(useBookingStore, ['setErrors', 'clearErrors']),
  },
  mounted() {},
}
</script>
